import Vue from 'vue';
import { INVOICE_TYPES } from '@/enums/invoiceType';
import invoiceService from '@/api/reservation/invoiceService';

const state = {
    isCreatingInvoice: false,
    isDownloadingInvoiceResume: false,
    isDownloadingInvoiceResumeBulk: false,
    isCancelingInvoice: false,
    isPrintingInvoice: false,
    valueToAskMoreBillingInfo: 1000,
    defaultInvoiceSystemPreset: {
        invoiceSystemType: 1,
        isActive: false,
        primaveraGetArticlesURL: '',
        primaveraPostInvoiceURL: '',
        primaveraGetInvoiceCreditNoteURL: '',
        primaveraGetInvoiceDocumentURL: ''
    },
    selectedInvoice: null,
    invoicingIntegrationOptions:[
        {
            id: 0,
            name: 'None'
        },
        {
            id: 1,
            name: 'Primavera'
        }
    ],
    invoicingOptions:[
        {
            id: 0,
            label:"Automatically"
        },
        {
            id: 1,
            label:"Manually"
        }
    ],
    invoiceTargetTypes:[
        {
            id: 0,
            label: 'End customer'
        },
        {
            id: 1,
            label: 'Agent'
        },
    ],
    invoiceTypes: INVOICE_TYPES,
    selectedReservationInvoiceResume: {},
    documentTypes: [],
    paymentTypes: [],
    chargeBackReasons: [],
    isResquestingDocumentTypes: false,
    isResquestingPaymentTypes: false,
    isResquestingChargeBackReason: false,
    selectedDocumentType: null,
    isResquestingPrimaveraSettings: false
};

const getters = {
    getSelectedInvoice: (state) => state.selectedInvoice,
    getDefaultInvoiceSystemPreset: (state) => state.defaultInvoiceSystemPreset,
    getInvoicingIntegrationOptions: (state) => state.invoicingIntegrationOptions,
    getInvoicingOptions: (state) => state.invoicingOptions,
    getInvoiceTargetTypes: (state) => state.invoiceTargetTypes,
    getInvoiceTypes: (state) => state.invoiceTypes,
    getIsCancellingInvoice: (state) => state.isCancelingInvoice,
    getIsPrintingInvoice: (state) => state.isPrintingInvoice,
    getIsCreatingInvoice: (state) => state.isCreatingInvoice,
    getIsDownloadingInvoiceResume: (state) => state.isDownloadingInvoiceResume,
    getIsDownloadingInvoiceResumeBulk: (state) => state.isDownloadingInvoiceResumeBulk,
    getValueToAskMoreBillingInfo: (state) => state.valueToAskMoreBillingInfo,
    getDocumentTypes: (state) => state.documentTypes,
    getPaymentTypes: (state) => state.paymentTypes,
    getChargeBackReason: (state) => state.chargeBackReasons,
    getIsDocumentTypesLoading: (state) => state.isResquestingDocumentTypes,
    getSelectedDocumentType: (state) => state.selectedDocumentType,
    getIsPrimaveraSettingsLoading: (state) => state.isResquestingPrimaveraSettings,
    getIsPaymentTypesLoading: (state) => state.isResquestingPaymentTypes,
    getIsChargeBackReasonsLoading: (state) => state.isResquestingChargeBackReason,
    getIsSendingInvoiceToMailLoading: (state) => state.isSendingInvoiceToMail,
};

const actions = {
    sendInvoiceToMail: ({state, commit, rootState}, payload) => {
        Vue.toasted.info(`Sending to ${payload.email}`, {duration: 2000});
        state.isSendingInvoiceToMail = true;
        
        return axios.get(`/api/invoice/Email?supplierId=${rootState.user.account.supplierId}&bookingInvoiceId=${payload.invoiceId}`)
        .then(response => {
            state.isSendingInvoiceToMail = false;

            if (response.status === 200) Vue.toasted.success('Sent', {duration: 2000});
        }).catch(err => {
            state.isSendingInvoiceToMail = false;
            
            Vue.toasted.error('Something went wrong', {duration: 2000});
        })
    },

    requestChargeBackReason: ({state, commit}) => {
        state.isResquestingChargeBackReason = true;
        
        return axios.get('/api/erp/chargebackreasons').then(response => {
            state.isResquestingChargeBackReason = false;

            if (response.status === 200) {
                commit('SET_CHARGE_BACK_REASONS', response.data);

                return response.data;
            }
        }).catch(err => {
            state.isResquestingChargeBackReason = false;
            
            return err;
        })
    },

    requestPaymentTypes: ({state, commit}) => {
        state.isResquestingPaymentTypes = true;
        
        return axios.get('/api/erp/paymentTypes').then(response => {
            state.isResquestingPaymentTypes = false;

            if (response.status === 200) {
                commit('SET_PAYMENT_TYPES', response.data);

                return response.data;
            }
        }).catch(err => {
            state.isResquestingPaymentTypes = false;
            
            return err;
        })
    },

    requestPrimaveraSettings: ({state, commit}) => {
        state.isResquestingPrimaveraSettings = true;
        
        return axios.get('/api/erp/primaveraSettings').then(response => {
            state.isResquestingPrimaveraSettings = false;

            if (response.status === 200) {
                return response.data;
            }
        }).catch(err => {
            state.isResquestingPrimaveraSettings = false;
            
            return err;
        })
    },

    requestDocumentTypes: ({state, commit}) => {
        state.isResquestingDocumentTypes = true
        
        return axios.get('/api/erp/documentTypes').then(response => {
            state.isResquestingDocumentTypes = false

            if (response.status === 200) {
                commit('SET_DOCUMENT_TYPES', response.data);
                
                return response.data;
            }
        }).catch(err => {
            state.isResquestingDocumentTypes = false
            
            return err;
        })
    },

    emitInvoice: ({state, commit, rootState}, payload) => {
        state.isCreatingInvoice = true;

        const requestData = {
            supplierId: rootState.user.account.supplierId,
            bookingId: payload.reservationId,
            invoiceTargetType: payload.invoiceTargetType,
            documentType: payload.documentType,
            client: payload.client
        };

        if (payload.paymentId != null) {
            requestData.paymentId = payload.paymentId;
        }

        if (payload.transactionCode != null) {
            requestData.transactionCode = payload.transactionCode;
        }

        return axios.post('/api/invoice/create', requestData).then(response => {
            state.isCreatingInvoice = false;

            return response;
        }).catch(err => {
            state.isCreatingInvoice = false;

            return err.response || err;
        })
    },

    emitInvoiceBulk: ({state, rootState}, payload) => {
        state.isCreatingInvoice = true

        // Set the correct "invoiceTargetType"
        let targetTypeId;
        
        if (payload.invoiceTo == 'customer') {
            targetTypeId = 0
        } else {
            if (payload.selectedAgent && payload.selectedAgent.isOTA == true) {
                targetTypeId = 2
            } else {
                targetTypeId = 1
            }
        }

        let dataToSend = {
            isToApplyAll: rootState.reservations.reservationListAllSelected,
            bookingList: rootState.reservations.bulkSelectedIds,
            isToManageInvoice: true,
            invoiceTargetType: targetTypeId,
            documentType: payload.documentType
        }

        return axios.post('/api/invoice/bulk', dataToSend).then(response => {
            state.isCreatingInvoice = false
            return response
        }).catch(err => {
            state.isCreatingInvoice = false
            return err
        })
    },

    cancelInvoice: ({state, rootState}, payload) => {
        state.isCancelingInvoice = true;

        return invoiceService.cancelInvoice(
            payload.booking.id,
            payload.invoice.id,
            payload.chargebackReason
        ).then(result => {
            state.isCancelingInvoice = false;

            return result;
        });
    },

    printInvoice: ({ state, commit, rootState }, payload) => {
        Vue.toasted.info('Your invoice is being prepared for download. Please allow a moment for processing.');
        state.isPrintingInvoice = true
        return axios.get('/api/invoice/document', {
            params: {
                bookingInvoiceId: payload
            },
            responseType: 'arraybuffer'
        }).then(response => {
            state.isPrintingInvoice = false
            return response

        }).catch(err => {
            state.isPrintingInvoice = false
            return err

        })
    },

    downloadReservationInvoiceResume: ({state, commit, rootState}, payload) => {
        state.isDownloadingInvoiceResume = true;
        
        const params = {
            bookingId: payload.reservationId,
            documentType: payload.docType
        };

        if (payload.paymentId != null) {
            params.paymentId = payload.paymentId;
        }

        if (payload.transactionCode != null) {
            params.transactionCode = payload.transactionCode;
        }

        return axios.get('/api/invoice/resume', {
            params: params
        }).then(response => {
            state.isDownloadingInvoiceResume = false;

            if(response.status == 200){
                commit('SET_RESERVATION_INVOICE_RESUME', response.data);
            }

            return response;
        }).catch(err => {
            state.isDownloadingInvoiceResume = false;

            throw err;
        })
    },

    downloadReservationInvoiceResumeBulk: ({state, commit, rootState}, payload) => {
        state.isDownloadingInvoiceResumeBulk = true

        let dataToSend = {
            bookingList: rootState.reservations.bulkSelectedIds,
            documentType: payload.documentType,
        }

        return axios.post('/api/invoice/executeBulkInvoicesCalculations', dataToSend).then(response => {
            state.isDownloadingInvoiceResumeBulk = false

            if(response.status == 200){
                commit('SET_RESERVATION_INVOICE_RESUME', response.data)
            }

            return response
        }).then(err => {
            state.isDownloadingInvoiceResumeBulk = false
            return err
        })
    },

    getBookingsFromInvoice: ({state, rootState}, payload) => {
        return axios.get('/api/Invoice/GetSupplierBookingsByInvoice', {
            params: {
                supplierId: rootState.user.account.supplierId,
                bookingInvoiceId: payload.bookingInvoiceId
            }
        }).then(response => {
            if(response.status == 200){
                return response.data
            }
            return response
        }).catch(err => {
            return err
        })
    },

    setSelectedDocumentType: ({commit}, payload) => {
        commit('SET_SELECTED_DOCUMENT_TYPE', payload);
    },

    setSelectedInvoice: ({commit}, payload) => {
        commit('SET_SELECTED_INVOICE', payload);
    },
};

const mutations = {
    SET_PAYMENT_TYPES: (state, payload) => {
        state.paymentTypes = payload;
    },

    SET_DOCUMENT_TYPES: (state, payload) => {
        state.documentTypes = payload;
    },

    SET_CHARGE_BACK_REASONS: (state, payload) => {
        state.chargeBackReasons = payload;
    },

    SET_SELECTED_DOCUMENT_TYPE: (state, payload) => {
        state.selectedDocumentType = payload;
    },

    SET_SELECTED_INVOICE: (state, payload) => {
        state.selectedInvoice = payload;
    },

    SET_RESERVATION_INVOICE_RESUME: (state, payload) => {
        state.selectedReservationInvoiceResume = payload;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/invoices.js